import { Card, Form, Button, Select, Table, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import "./style.css";
import {
  useFetchRestaurantDataQuery,
  useDeleteRestaurantDataMutation,
} from "./restaruant.service";
import { useNavigate } from "react-router-dom";

const Restaruant = () => {
  const {
    data = {
      data: {
        restaurants: [],
      },
    },
    isSuccess,
  } = useFetchRestaurantDataQuery();

  const navigate = useNavigate();

  const [deleteRestaurantData, { isLoading: isDeleteLoading }] =
    useDeleteRestaurantDataMutation();

  const [form] = Form.useForm();

  const handleDeleteRestaurant = async (id) => {
    await deleteRestaurantData(id);
    form.resetFields();
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <span>{text}</span>,
    },
    // {
    //   title: "Email",
    //   dataIndex: "owner",
    //   render: (text) => <span>{text?.email}</span>,
    // },
    {
      title: "Address",
      dataIndex: "address",
      render: (text) => <span>{text.country}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            size="small"
            onClick={() => navigate(`/restaurant/${record._id}`)}
          >
            Edit
          </Button>

          <Button
            type="default"
            color="danger"
            variant="solid"
            icon={<DeleteOutlined />}
            size="small"
            loading={isDeleteLoading}
            onClick={() => handleDeleteRestaurant(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
      width: "15%",
    },
  ];

  const {
    data: { restaurants },
  } = data;

  return (
    <Card
      title="Restaurant List"
      style={{ fontSize: "20px" }}
      bordered={false}
      extra={
        <Button
          variant="solid"
          type="primary"
          onClick={() => navigate("/restaurant/create")}
        >
          Create
        </Button>
      }
    >
      <Table columns={columns} dataSource={restaurants} rowKey="key" />
    </Card>
  );
};

export default Restaruant;
